import { render } from "./approvals.vue?vue&type=template&id=256ae71d&scoped=true&ts=true"
import script from "./approvals.vue?vue&type=script&lang=ts"
export * from "./approvals.vue?vue&type=script&lang=ts"

import "./approvals.vue?vue&type=style&index=0&id=256ae71d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-256ae71d"]])

export default __exports__